module.exports = __webpack_public_path__ + "img/blog-sanitrit.8914ade7.jpg";